import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {Response, URLSearchParams} from "@angular/http";

@Injectable()
export class VehiclesService {

    constructor(private backendService: ObservableBackendService) {
    }

    public findVehicles(filter: Vehicle, page: number, itemsPerPage: number): Observable<Page> {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("vehicles", params);
    }

    public downloadFilterVehicles(filter: Vehicle, page: number, itemsPerPage: number): Observable<Response> {
        return this.backendService.getAttachment("vehiclesReport", VehiclesService.setParams(filter, page, itemsPerPage));
    }

    public static getURLFilterVehicles(filter: Vehicle, page: number, itemsPerPage: number): string {
        return "/vehiclesReport?" + VehiclesService.setParams(filter, page, itemsPerPage).toString();
    }

    public static getURLVehicleBulkload(documentId: string): string {
        return "/vehiclesBulkloadDocument/" + documentId;
    }

    public downloadFilterVehiclesForIE(filter: Vehicle, page: number, itemsPerPage: number): string {
        return window.location.origin + '/vehiclesReport?' + VehiclesService.setParams(filter, page, itemsPerPage).toString();
    }

    private static setParams(filter: Vehicle, page: number, itemsPerPage: number): URLSearchParams {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return params;
    }

    public save(vehicle: Vehicle): Observable<Vehicle> {
        return vehicle.id != null
            ? this.backendService.post("vehicle", vehicle, null)
            : this.backendService.put("vehicle", vehicle, null);
    }

    public delete(contractId: string, vehicleId: string): Observable<Vehicle> {
        return this.backendService.delete("vehicle/" + contractId + "/" + vehicleId, null, null);
    }

    public getVehiclesType(): Observable<any> {
        return this.backendService.get("vehiclesType", null);
    }

    public getVehiclesBrand(): Observable<any> {
        return this.backendService.get("vehiclesBrand", null);
    }

    public getVehicle(contractId: string, vehicleId: string): Observable<Vehicle> {
        return this.backendService.get("vehicle/" + contractId + "/" + vehicleId, null);
    }

    public getVehicleByPatent(patent: string): Observable<Vehicle> {
        return this.backendService.get("vehicle/" + patent, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/vehicles.service.ts
 **/